<template>
  <div @click.prevent="onStateToggleClick">
    <donut-input-toggle
      :model-value="modelValue"
      size="small"
    />
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { state, commit, dispatch } = useStore();
  const props = defineProps({
    user: { type: Object, required: true },
  });

  const modelValue = computed(() => {
    const effectiveValue = state.pointsLeaderboard.asyncValuesByUser[props.user.id]?.state || props.user.points.state;
    return effectiveValue !== 'inactive';
  });

  const onStateToggleClick = () => {
    // Because the specific nature of this toggle sometimes opens a modal, we want to just intercept
    // all clicks on it and handle the logic in a bespoke manner here.
    if (modelValue.value) {
      commit('updateModal', {
        visible: true,
        subcomponent: 'shoutouts-leaderboard-modals-deactivate-wallet',
        data: { user: props.user },
      });
    } else {
      dispatch('pointsLeaderboard/updateWalletState', { user: props.user, value: 'active_billed' });
    }
  };
</script>
